import React, { memo, useEffect, useState } from 'react'
import Link from 'next/link'
import { useRouter } from 'next/router'
import Image from 'next/image'
import clsx from 'clsx'
import { styled } from '@mui/material/styles'
import Button from '@mui/material/Button'
import AppBar from '@mui/material/AppBar'
import Toolbar from '@mui/material/Toolbar'
import MenuIcon from '@mui/icons-material/Menu'
import Box from '@mui/material/Box'
import SwipeableDrawer from '@mui/material/SwipeableDrawer'
import IconButton from '@mui/material/IconButton'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemText from '@mui/material/ListItemText'
import ClearIcon from '@mui/icons-material/Clear'
import { useIntl } from 'react-intl'
import Sticky from 'react-sticky-el'
import useUtms from 'hooks/useUtms'
import usePageProps from 'hooks/usePageProps'
import WhatsAppIcon from 'components/icons/whatsapp_icon.svg'
import Easylogo from 'public/img/easy/Easylogo.png'
import { whatsappEasyAgencias } from 'vars'
import sx from './styles'

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
  justifyContent: 'flex-end',
}))

const HeaderLanding = (props) => {
  const {
    logo = '',
    logoAltText = '',
    position = 'relative',
    hideMenu = false,
    whatsappMessage,
  } = props
  const router = useRouter()
  const query = useUtms()
  const { formatMessage: f } = useIntl()
  const [inverted, setInverted] = useState(false)
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const { easyLandingMenu, whatsappEasy, isEasyAgencias } = usePageProps()
  const toggleInverted = (val) => setInverted(val)
  const whatsapp = isEasyAgencias ? whatsappEasyAgencias : whatsappEasy

  const toggleDrawer = (open) => (event) => {
    if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return
    }
    setMobileMenuOpen((prev) => (open === undefined ? !prev : open))
  }
  useEffect(() => {
    setMobileMenuOpen(false)
  }, [router.pathname])

  const handleRouter = () => {
    if (isEasyAgencias) {
      router.push('/easy-agencias')
    } else {
      router.push('/easy')
    }
  }

  const menu = (
    <Box sx={sx.menu}>
      {easyLandingMenu.filter((item) => !item.hiddenHeader).map((item) => {
        return (
          <Link
            key={item.id}
            href={`${item.url}${query}`}
            passHref
          >
            <Button
              key={item.id}
              sx={sx.menuItem}
              id={item.link_id}
              title={item.alt}
              size="small"
            >
              {item.title}
            </Button>
          </Link>
        )
      })}
    </Box>
  )

  const whatsappIcon = (
    <Box sx={sx.mobileMenu}>
      <IconButton
        size="small"
        sx={sx.whatsappTag}
        component="a"
        disableRipple
        href={`//wa.me/${whatsapp}?text=${whatsappMessage}`}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={f({ id: 'SEND_US_A_WHATSAPP' })}
      >
        <WhatsAppIcon />
      </IconButton>
    </Box>
  )

  const mobileMenu = (
    <Box sx={sx.mobileMenu}>
      <>

        {whatsappIcon}

        {!hideMenu && (
          <>
            <IconButton
              sx={sx.mobileMenuIcon}
              onClick={toggleDrawer()}
              aria-label={f({ id: mobileMenuOpen ? 'HIDE_MOBILE_MENU' : 'SHOW_MOBILE_MENU' })}
            >
              <MenuIcon sx={sx.blueIcon} />
            </IconButton>

            <SwipeableDrawer
              anchor="right"
              open={mobileMenuOpen}
              onClose={toggleDrawer(false)}
              onOpen={toggleDrawer(true)}
              sx={sx.drawer}
            >
              <DrawerHeader sx={sx.drawerHeader}>
                <Box
                  sx={{
                    cursor: 'pointer',
                    display: 'block',
                    width: '80px',
                  }}
                  onClick={handleRouter}
                >
                  <Image
                    src={Easylogo}
                    alt={logoAltText}
                    style={{ width: '100%', height: 'auto' }}
                    priority
                  />
                </Box>
                <Box>

                  <IconButton
                    onClick={toggleDrawer(false)}
                    aria-label={f({ id: 'CLOSE' })}
                  >
                    <ClearIcon sx={{ ...sx.blueIcon, ...sx.clearIcon }} />
                  </IconButton>
                </Box>
              </DrawerHeader>
              <List sx={sx.mobileMenuListItem}>
                {easyLandingMenu.filter((item) => !item.hiddenHeader).map((item) => (
                  <Link
                    key={item.id}
                    href={item.url}
                    passHref
                  >
                    <ListItem
                      sx={sx.mobileMenuItem}
                      onClick={toggleDrawer(false)}
                      divider
                    >
                      <ListItemText primary={item.title} />
                    </ListItem>
                  </Link>
                ))}
              </List>
            </SwipeableDrawer>
          </>
        )}
      </>
    </Box>
  )

  return (
    <Sticky
      onFixedToggle={toggleInverted}
      topOffset={inverted ? 4 : 0}
      className="wrapper-stycky-header"
    >
      <AppBar
        position={position}
        elevation={inverted ? 2 : 0}
        sx={sx.appbar}
        className={clsx({ scrolled: inverted })}
      >
        <Toolbar disableGutters>

          <Box sx={sx.logoContainer}>
            <Box
              sx={{
                cursor: 'pointer',
                display: 'block',
                width: { lg: '110px', xs: '80px' },
              }}
              onClick={handleRouter}
            >
              {typeof logo === 'string' ? (
                <Image
                  src={Easylogo}
                  alt={logoAltText}
                  style={{ width: '100%', height: 'auto' }}
                  priority
                />
              ) : (
                <Easylogo />
              )}
            </Box>

          </Box>
          {!hideMenu && (
            menu
          )}
          {mobileMenu}
        </Toolbar>
      </AppBar>
    </Sticky>
  )
}

export default memo(HeaderLanding)
